export const company = {
    name: 'Appsolute LLC',
    email: 'ADMIN@APP-SOLUTE.COM',
    address: 'Prazka St. 3, Kiev, Ukraine, 02090',
    country: 'Ukraine',
    link: 'https://chrome.google.com/webstore/detail/nature-wallpapers/pmlldhbhhcbniejhkfcabmlmijimlcke?hl=en&authuser=3',
    mainTitle: 'Over 100+ of the best nature wallpaper images with our extension!',
    mainSubTitle: 'Enjoy our wallpapers'
}